import { List } from 'immutable';
import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import FilterLogicGroup from '../filterQueryFormat/logic/FilterLogicGroup';
import * as LogicGroup from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { ObjectTypeIdRegex } from '../filterQueryFormat/ObjectTypeId';
export const conditionsGrouping = {
  maybeAlreadyExistingFilterFamilyGroupKey: (group, filterFamily) => {
    if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily)) {
      for (const key of group.conditions.keys()) {
        if (group.conditions.getIn([key, 'filterFamily']) === filterFamily) {
          return key;
        }
      }
    }
    return undefined;
  },
  applyConditionToGroup: (filterFamily, condition, draftValue, applyDraftToGroup, getGroup, isEditMode) => {
    const selectedSubGroup = getGroup(draftValue);
    const existingFilterFamilySubgroupKey = conditionsGrouping.maybeAlreadyExistingFilterFamilyGroupKey(selectedSubGroup, filterFamily);
    if (!isEditMode && existingFilterFamilySubgroupKey) {
      // if  new condition being added (isEditMode -> editing existing filter)
      // and draftValue and selectedSubGroup are the same
      // it means that editor is used in AND mode only (no wrapping OR group)
      // therefore we need to skip selectedSubGroup index in the keyPath
      const keyPath = LogicGroup.is(draftValue, selectedSubGroup) ? List([existingFilterFamilySubgroupKey]) : List([draftValue.conditions.findKey(value => value === selectedSubGroup), existingFilterFamilySubgroupKey]);
      return LogicGroup.addToKeyPath(keyPath, condition, draftValue, filterFamily);
    }
    return applyDraftToGroup(condition, draftValue, filterFamily);
  },
  isAssetMembershipFilterFamily: filterFamily => {
    if (testDynamicFilterFamily(DSAssetFamilies.DATASET, filterFamily) || testDynamicFilterFamily(DSAssetFamilies.IN_LIST, filterFamily) || testDynamicFilterFamily(DSAssetFamilies.IMPORT, filterFamily) || filterFamily === DSAssetFamilies.WORKFLOW) {
      return true;
    }
    return false;
  }
};
export const getDisabledFilterFamilies = activeGroup => {
  const disabledFilterFamilies = {};
  if (FilterLogicGroup.isFilterLogicGroup(activeGroup)) {
    activeGroup.conditions.forEach(condition => {
      if (condition.filterFamily) {
        const newCounter = disabledFilterFamilies[condition.filterFamily] ? disabledFilterFamilies[condition.filterFamily] + 1 : 1;
        disabledFilterFamilies[condition.filterFamily] = newCounter;
      }
    });
  }
  return Object.keys(disabledFilterFamilies).reduce((acc, filterFamily) => {
    acc[filterFamily] = !ObjectTypeIdRegex.test(filterFamily) && disabledFilterFamilies[filterFamily] > 1;
    return acc;
  }, {});
};